// Finance module — client entry point.
// Routes are defined in routes.tsx (JSX requires .tsx extension).
// App.tsx still hard-codes the same routes (intentionally duplicated until F.2
// removes the App.tsx block and switches to registry-driven rendering).

import type {
  ClientCardContribution,
  ClientModule,
  ClientWidgetContribution,
} from '../../../client/src/modules/registry.js';
import { financeManifest } from '../manifest.js';
import { financePanelTypes } from './entity-panels.js';
import { financeRoutes } from './routes.js';
import { financeRedirects } from './redirects.js';
import { financeArtifactPreviewContribution } from './artifacts/finance-artifact-preview.contribution.js';

const financeWidgets: ClientWidgetContribution[] = [
  {
    id: 'finance.risk-status',
    lazy: () => import('./widgets/RiskStatusWidget.js').then((m) => ({ default: m.RiskStatusWidget })),
    suitableFor: ['dashboard.trading'],
    title: 'Risk Status',
  },
];

// Conversation cards finance owns; these override the core placeholders for
// cards whose `moduleId` is 'finance'.
const financeCards: ClientCardContribution[] = [
  {
    cardType: 'strategy_list',
    lazy: () => import('./cards/StrategyListCard.js').then((m) => ({ default: m.StrategyListCard })),
  },
  {
    cardType: 'strategy_detail',
    lazy: () => import('./cards/StrategyDetailCard.js').then((m) => ({ default: m.StrategyDetailCard })),
  },
  {
    cardType: 'comparison',
    lazy: () => import('./cards/ComparisonCard.js').then((m) => ({ default: m.ComparisonCard })),
  },
];

export const financeClientModule: ClientModule = {
  manifest: financeManifest,
  routes: [...financeRoutes, ...financeRedirects],
  widgets: financeWidgets,
  artifactPreviews: [financeArtifactPreviewContribution],
  cards: financeCards,
  panelTypes: financePanelTypes,
};
